/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_EyebrowInputs */

const en_auth_login_eyebrow = /** @type {(inputs: Auth_Login_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

const pl_auth_login_eyebrow = /** @type {(inputs: Auth_Login_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się`)
};

/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Auth_Login_EyebrowInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_login_eyebrow = /** @type {((inputs?: Auth_Login_EyebrowInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_EyebrowInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_login_eyebrow(inputs)
	return en_auth_login_eyebrow(inputs)
});